// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export const IS_CUSTOM_DOMAIN = Boolean(process.env.IS_CUSTOM_DOMAIN === '1' || '');